
import { defineComponent } from "vue";
import Login from "@/components/Login.vue";
import { SHA256 } from "crypto-js";

function sleep(ms:number = 1000){
  return new Promise((resolve, reject)=>{
    window.setTimeout(resolve, ms);
  });
}

export default defineComponent({
  name: "App",
  components:{
    Login
  },
  data():{
    auth: boolean | null,
  }{
    return{
      auth: null,
    }
  },
  mounted(){
    this.checkLogin();
  },
  methods: {
    checkLogin(){
      const query: {[key:string] : string} = {};
      location.search.replace('?','').split('&').forEach(element => {
        const parts = element.split('=');
        if(parts[1]){
          query[parts[0]] = parts[1];
        }
      });
      if(query.pass){
        localStorage.setItem('password', query.pass);
      }
      
      const savedPassword = localStorage.getItem('password') || '';
      if(SHA256(savedPassword).toString() === 'ca1a0b5a884c5056744095a293afb73e5742de50abbe0ff134586f50673b40c1'){
        this.auth = true;
      } else {
        this.auth = false;
      }
    }
  }
});
